export const genders = [
  { id: 'Male', name: 'Male' },
  { id: 'Female', name: 'Female' },
]

export const nameSuffixes = [
  {id: "Sr.", name: "Sr."},
  {id: "Jr.", name: "Jr."},
  {id: "II", name: "II"},
  {id: "III.", name: "III"},
  {id: "IV", name: "IV"},
  {id: "V", name: "V"},
  {id: "VI", name: "VI"},
  {id: "VII", name: "VII"},
]
